import script from "./crew.vue?vue&type=script&setup=true&lang=ts"
export * from "./crew.vue?vue&type=script&setup=true&lang=ts"

import "./crew.vue?vue&type=style&index=0&id=ed4eb63a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed4eb63a"]])

export default __exports__